/* eslint-disable import/no-default-export */
// eslint-disable-next-line no-restricted-imports
import { forNamespace } from 'common/lib/util/i18n';
import React from 'react';
import styles from './private-board-info.less';

const format = forNamespace('private board limit info', {
  shouldEscapeStrings: false,
});

interface PrivateBoardInfoProps {
  orgName: string;
  upgradeUrl: string;
  onMouseEnter?: React.MouseEventHandler<HTMLDivElement>;
  onMouseLeave?: React.MouseEventHandler<HTMLDivElement>;
}

const getText = ({ orgName, upgradeUrl }: PrivateBoardInfoProps) => {
  // Localize the translations to be used within other translations (translaception)
  const upgradeLink = (
    <a key="upgrade-link" href={upgradeUrl}>
      {format('upgrade to business class', { orgName })}
    </a>
  );

  return format('private board', {
    upgradeLink,
  });
};

const PrivateBoardInfo: React.FunctionComponent<PrivateBoardInfoProps> = ({
  onMouseEnter,
  onMouseLeave,
  ...otherProps
}) => (
  <div
    className={styles.whiteBox}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
  >
    {getText(otherProps)}
  </div>
);

export default PrivateBoardInfo;



// WEBPACK FOOTER //
// ./app/common/components/create-board/private-board-info.tsx